import { Booking, EventType, Schedule } from "../types";
import { weekdays } from "../config/schedule";
import dayjs from "dayjs";

export function weekdaySummary(schedule: Schedule) {
  return weekdays.filter((day) => schedule.weekdays.includes(day.value)).map((day) => day.label).join(", ");
}

export function filterBookingsByCategory(bookings: Booking[], events: EventType[], category: EventType["category"]) {
  return bookings.filter((booking) => {
    const event = events.find((item) => item.id === booking.eventId);
    if (event) return event.category === category;
    return inferCategoryFromText(`${booking.eventId} ${booking.eventTitle}`) === category;
  });
}

export function getScheduleStartForDate(event: EventType, date: string) {
  const parsed = dayjs(date);
  if (!parsed.isValid()) return event.schedule.startTime || "12:00";
  const override = event.schedule.dateOverrides?.[date];
  const weekly = event.schedule.weeklyHours?.[String(parsed.day())];
  return override?.startTime || weekly?.startTime || event.schedule.startTime || "12:00";
}

export function summarizeClosedDates(dates: string[]) {
  if (!dates.length) return "байхгүй";
  const sorted = [...dates].sort();
  const preview = sorted.slice(0, 6).join(", ");
  return sorted.length > 6 ? `${preview} ... (+${sorted.length - 6})` : preview;
}

export function isPortraitEvent(event: EventType) {
  if (event.category === "portrait") return true;
  return inferCategoryFromText(`${event.id} ${event.title}`) === "portrait";
}

export function inferCategoryFromText(text: string): EventType["category"] {
  const value = text.toLowerCase();
  return value.includes("portrait") || value.includes("hurug") || value.includes("хөрөг") ? "portrait" : "regular";
}
